import { render, staticRenderFns } from "./MailTable.vue?vue&type=template&id=30d74031&scoped=true"
import script from "./MailTable.vue?vue&type=script&lang=ts"
export * from "./MailTable.vue?vue&type=script&lang=ts"
import style0 from "./MailTable.vue?vue&type=style&index=0&id=30d74031&prod&lang=css"
import style1 from "./MailTable.vue?vue&type=style&index=1&id=30d74031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d74031",
  null
  
)

export default component.exports